import Dashboard from "./container"

/** 
 * @module Dashboard
 * @description 戰情室儀表元件模組
 */

export default Dashboard;